import { ValidationRuleTypeEnum } from "./ValidationRuleType";

class ValidationRule {
    public Id: string;
    public CountryLookupId: string;
    public RegionLookupId: string;
    public ValidationRuleTypeId: ValidationRuleTypeEnum;
    public ValidationErrorMessageLookupId: string;
    public Description: string;
    public EditMaskPattern: string;
    public ValidationRegexPattern: string;
    public DisplayFormatSubstitution: string;
    public DisplayFormatSelectorPatern: string;
}

export { ValidationRule };
